import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class TenantService {
  get tenantId$(): Observable<string | null> {
    return this._tenantId$.pipe(
      filter(tenantId => tenantId != null)
    );
  }

  get tenantId(): string | null {
    return this._tenantId$.value;
  }

  private _tenantId$ = new BehaviorSubject<string>(null);

  registerTenant(tenantId: string) {
    this._tenantId$.next(tenantId);
  }
}
